module.exports = __webpack_public_path__ + "images/3c8c0dfd0c8ee40dea02120d60c4fa05map.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.png
// module id = EoJS
// module chunks = 0